import React from "react";
import { View, StyleSheet, ActivityIndicator, Pressable } from "react-native";
import Text from "./DsText";
import { tokens } from "./tokens";

const BottomButton = ({
  title,
  onPress = () => {},
  disabled = false,
  loading = false,
  testID = "receiving-bottom-cta",
}) => {
  return (
    <View style={styles.container}>
      <Pressable
        testID={testID}
        disabled={disabled || loading}
        onPress={onPress}
        style={[styles.btn, (disabled || loading) && styles.btnDisabled]}
      >
        {loading ? (
          <ActivityIndicator size="small" color={tokens.surface} />
        ) : (
          // variant="body_text_1" (Regular), not title_16 (Bold) — this
          // CTA's Hindi copy ("रैकिंग पूरी करें" etc.) silently loses its
          // tail word painted Bold on this build (see TabList.js / TpRow.js
          // commit notes); Regular is the confirmed-clean weight.
          <Text variant="body_text_1" style={styles.text}>
            {title}
          </Text>
        )}
      </Pressable>
    </View>
  );
};

export default BottomButton;

const styles = StyleSheet.create({
  container: {
    backgroundColor: tokens.surface,
    paddingHorizontal: tokens.spacing.large,
    paddingVertical: tokens.spacing.medium,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: tokens.borderLight,
  },
  btn: {
    backgroundColor: tokens.primary,
    paddingVertical: 12,
    borderRadius: tokens.radius.md,
    alignItems: "center",
    justifyContent: "center",
  },
  btnDisabled: { backgroundColor: tokens.disabled },
  text: { color: tokens.surface },
});
